import SliderNav from "../../Assets/SliderNav/SliderNav"
import { SwiperOptions } from "swiper/types/swiper-options"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import { StarIcon } from "../../../icons/StarIcon"
import ArticlePrevItem from "../ArticlePrevItem/ArticlePrevItem"
import { useAppSelector } from "../../../hooks"
import { selectArticles } from "../../../redux/slice/articles"
import "swiper/css"
import { useEffect, useMemo, useState } from "react"
import useWindowSize from "../../../hooks/useWindowSize"
import { useTranslation } from "react-i18next"
import { selectUser } from "../../../redux/slice/auth"
import styles from "./ArticlesFavorites.module.scss"
import { IArticle } from "../../../types/content"

const ArticlesFavorites = () => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const { favoriteArticles } = useAppSelector(selectArticles)
  const user = useAppSelector(selectUser)
  const { isDesktop, isMobile } = useWindowSize()
  const [favoriteList, setFavoriteList] = useState<IArticle[]>([])

  useEffect(() => {
    setFavoriteList(favoriteArticles || [])
  }, [favoriteArticles])

  const swiperParams: SwiperOptions = useMemo(() => {
    let countViewSlides = 0
    if (isDesktop) {
      countViewSlides = 3
    }
    if (isMobile) {
      countViewSlides = 1
    }
    if (!isDesktop && !isMobile) {
      countViewSlides = 2
    }

    const params = {
      slidesPerView: countViewSlides,
      modules: [Navigation],
      navigation: {
        prevEl: `.${styles.nav} .slider-prev-btn`,
        nextEl: `.${styles.nav} .slider-next-btn`,
      },
    }
    return params
  }, [favoriteList, isDesktop, isMobile])

  const slides = useMemo(() => {
    const result = favoriteList.reduce((accumulator: any[], currentValue, index) => {
      if (isMobile) {
        if (index % 3 === 0) {
          accumulator.push([])
        }
      } else {
        accumulator.push([])
      }
      accumulator[accumulator.length - 1].push(currentValue)
      return accumulator
    }, [])

    return result.map((item, index) => (
      <SwiperSlide key={index}>
        {item.map((itemInner: any) => (
          <ArticlePrevItem key={itemInner.id} {...itemInner} className={styles.item} />
        ))}
      </SwiperSlide>
    ))
  }, [favoriteList, isDesktop, isMobile])

  useEffect(() => {
    if (!user?.id) return
    if (typeof window.Echo === "undefined") return

    const changeNameBySocket = (event: {
      created_by: string
      id: string
      text: string
      parent_id: string | 0
      sort: number | 0
      view_count: number
    }) => {
      // text в этих данных - это имя статьи(он же name при получении отдельной статьи), а не её содержание
      if (!event?.id) return
      setFavoriteList((prev) => {
        const clone = [...prev]
        const index = clone.findIndex((item) => item.id === event.id)
        if (index < 0) return prev
        clone[index] = { ...clone[index], text: event.text }
        return clone
      })
    }
    const deleteArticle = (event: { id: string }) => {
      if (!event?.id) return
      setFavoriteList((prev) => prev.filter((item) => item.id !== event.id))
    }

    const channelArticlesPublic = window.Echo.join(`articlesPublic`)
    const channelArticles = window.Echo.join(`articles`)
    channelArticlesPublic?.listen(".changeNameArticlePublic", changeNameBySocket)
    channelArticles?.listen(".updateTable", deleteArticle)

    return () => {
      channelArticlesPublic?.stopListening(".changeNameArticlePublic", changeNameBySocket)
      channelArticles?.stopListening(".updateTable", deleteArticle)
    }
  }, [user])

  if (!favoriteArticles?.length) return null

  return (
    <div className={styles.wrap}>
      <header className={styles.header}>
        <h4 className={styles.title}>{t("favorites")}</h4>
        <span className={styles.iconWrap}>
          <StarIcon />
        </span>
        <SliderNav className={styles.nav} mode={"white"} />
      </header>

      <Swiper {...swiperParams}>{slides}</Swiper>
    </div>
  )
}

export default ArticlesFavorites
